import { createRouter, createWebHashHistory } from "vue-router";
import DashboardPage from "@/views/student/studentDashboard/DashboardPage.vue";
import LoginPage from "@/views/auth/LoginPage.vue";
import RegisterPage from "@/views/auth/RegisterPage.vue";
import PasswordResetPage from "@/views/auth/PasswordResetPage.vue"
import OnBoardingPage from "@/views/auth/OnboardingPage.vue"
import StudentOnBoardingPage from "@/views/student/StudentOnboarding.vue"
import TutorOnBoardingPage from "@/views/tutor/TutorOnboarding.vue"
import { useAuthStore } from "@/stores/authStore";
import OtpPage from "@/views/auth/OtpPage.vue";
import { notifyError } from "@/utils/notification";
import StudentSettingsPage from "@/views/settings/StudentSettingsPage.vue";
import TutorSettingsPage from "@/views/settings/TutorSettingsPage.vue"
import InstituteSettingsPage from "@/views/settings/InstituteSettingsPage.vue"
import ClassConfirmations from "@/views/student/studentDashboard/ClassConfirmations.vue";
import TutorEnrollments from "@/views/student/studentDashboard/TutorEnrollments.vue";
import StudentNotes from "@/views/student/studentDashboard/StudentNotes.vue";
import StudentResults from "@/views/student/studentDashboard/StudentResults.vue";
import HomeWork from "@/views/student/studentDashboard/HomeWork.vue";
import StudentRevision from "@/views/student/studentDashboard/StudentRevision.vue";
import PastPapers from "@/views/student/studentDashboard/PastPapers.vue";
import TutorDashboardPage from "@/views/tutor/tutorDashboard/TutorDashboardPage.vue";
import ClassRequests from "@/views/tutor/tutorDashboard/ClassRequests.vue";
import TutorNotice from "@/views/tutor/tutorDashboard/TutorNotice.vue";
import EnrolledStudents from "@/views/tutor/tutorDashboard/EnrolledStudents.vue";
import TodoList from "@/views/tutor/tutorDashboard/TodoList.vue";
import Programs from "@/views/tutor/tutorDashboard/TutorProgrammes.vue";
import TutorPastPapers from "@/views/tutor/tutorDashboard/PastPapers.vue";
import PaymentsPage from "@/views/payments/PaymentsPage.vue";
import PaymentSuccess from "@/views/payments/PaymentSuccess.vue";
import PaymentFailed from "@/views/payments/PaymentFailed.vue";
import AdminPaymentsPage from "@/views/admin/PaymentsPage.vue";
import TutorPayoutsPage from "@/views/admin/TutorPayoutsPage.vue";
import RequestClass from "@/views/student/RequestClass.vue";
import RequestClassSuccess from "@/views/student/RequestClassSuccess.vue";
import InstituteDashboardPage from "@/views/institute/instituteDashboard/InstituteDashboardPage.vue";
import OurTutors from "@/views/institute/instituteDashboard/OurTutors.vue";
import OurStudents from "@/views/institute/instituteDashboard/OurStudents.vue";
import StudentProfile from "@/views/publicProfile/studentProfile.vue";
import TutorProfile from "@/views/publicProfile/tutorProfile.vue";
import TempTutorProfiles from "@/views/student/TempTutorProfiles.vue";
import TutorReviewPage from "@/views/student/AddTutorReview.vue"
import Students from "@/views/admin/StudentsPage.vue";
import TutorsPage from "@/views/admin/TutorsPage.vue";
import InstitutionsPage from "@/views/admin/InstitutionsPage.vue";
import VerificationRequestsPage from "@/views/admin/VerificationRequestsPage.vue";
import StudentReviewsPage from "@/views/admin/StudentReviewsPage.vue";
import GradeManagementPage from "@/views/admin/GradeManagementPage.vue";
import UsersPage from "@/views/admin/UsersPage.vue";
import SettingsPage from "@/views/admin/SettingsPage.vue";
import PastPapersPage from "@/views/admin/PastPapers.vue";
import DiscountsPage from "@/views/admin/DiscountsPage.vue";
import AdminTutorProfile from "@/views/adminPublicProfile/tutorProfile.vue";
import InstituteOnboarding from "@/views/institute/InstituteOnboarding.vue";
import PendingInvitations from "@/views/institute/instituteDashboard/PendingInvitations.vue";
import PendingStudents from "@/views/institute/instituteDashboard/PendingStudents.vue";

//Landing Pages
import HomePage from "@/views/landingPages/HomagePage.vue";
import AboutUsPage from "@/views/landingPages/AboutUsPage.vue";
import BecomeTutorPage from "@/views/landingPages/BecomeTutorPage.vue";
import MatchTutorPage from "@/views/landingPages/MatchTutorPage.vue";
import PricingPage from "@/views/landingPages/PricingPage.vue";
import PrivacyPage from "@/views/landingPages/PrivacyPage.vue";
import TermPage from "@/views/landingPages/TermPage.vue";
import LegalPage from "@/views/landingPages/LegalCenter.vue";
import LegalNotice from "@/views/landingPages/LegalNotice.vue";


const routes = [
  { path: "/", component: HomePage },
  { path: "/aboutUs", component: AboutUsPage },
  { path: "/becomeTutor", component: BecomeTutorPage },
  { path: "/matchTutor", component: MatchTutorPage },
  { path: "/pricing", component: PricingPage },
  { path: "/privacy-policy", component: PrivacyPage },
  { path: "/termsOfService", component: TermPage },
  { path: "/legal-center", component: LegalPage },
  { path: "/legal-notice", component: LegalNotice },

  { path: "/login", component: LoginPage },
  { path: "/registration", component: RegisterPage },
  { path: "/passwordReset", component: PasswordResetPage },
  { path: "/verify", component: OtpPage },
  { path: "/onBoarding", component: OnBoardingPage },
  { path: "/studentOnBoarding", component: StudentOnBoardingPage, meta: { requiresAuth: false } },
  { path: "/tutorOnBoarding", component: TutorOnBoardingPage, meta: { requiresAuth: false } },
  { path: "/studentSettings", component: StudentSettingsPage, meta: { requiresAuth: true } },
  { path: "/tutorSettings", component: TutorSettingsPage, meta: { requiresAuth: true } },
  { path: "/institutionOnBoarding", component: InstituteOnboarding, meta: { requiresAuth: false } },
  { path: "/studentProfile/:id", component: StudentProfile, meta: { requiresAuth: true } },
  { path: "/tutorProfile/:id", component: TutorProfile, meta: { requiresAuth: false } },

  // Student Dashboard routes
  { path: "/student_dashboard", component: DashboardPage, meta: { requiresAuth: true } },
  { path: "/student_dashboard/confirmations", component: ClassConfirmations, meta: { requiresAuth: true } },
  { path: "/student_dashboard/enrolledTutors", component: TutorEnrollments, meta: { requiresAuth: true } },
  { path: "/student_dashboard/studentNotes", component: StudentNotes, meta: { requiresAuth: true } },
  { path: "/student_dashboard/studentResults", component: StudentResults, meta: { requiresAuth: true } },
  { path: "/student_dashboard/homework", component: HomeWork, meta: { requiresAuth: true } },
  { path: "/student_dashboard/revision", component: StudentRevision, meta: { requiresAuth: true } },
  { path: "/student_dashboard/pastPapers", component: PastPapers, meta: { requiresAuth: true } },
  { path: "/student_dashboard/request-a-class/:tutorId", component: RequestClass, meta: { requiresAuth: true } },
  { path: "/student_dashboard/request-a-class/:tutorId/success", component: RequestClassSuccess, meta: { requiresAuth: true } },
  { path: "/student_dashboard/test-tutor-profiles", component: TempTutorProfiles, meta: { requiresAuth: true } },
  { path: "/student_dashboard/tutor-review", component: TutorReviewPage, meta: { requiresAuth: true } },

  // Tutor Dashboard routes
  { path: "/tutor_dashboard", component: TutorDashboardPage, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/classRequests", component: ClassRequests, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/tutorNotice", component: TutorNotice, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/enrolledStudents", component: EnrolledStudents, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/to-do-list", component: TodoList, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/payments", component: PaymentsPage, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/programs", component: Programs, meta: { requiresAuth: true } },
  { path: "/tutor_dashboard/pastPapers", component: TutorPastPapers, meta: { requiresAuth: true } },

  // Institute Dashboard routes
  { path: "/institution_dashboard", component: InstituteDashboardPage, meta: { requiresAuth: true } },
  { path: "/ourTutors", component: OurTutors, meta: { requiresAuth: true } },
  { path: "/pendingInvitations", component: PendingInvitations, meta: { requiresAuth: true } },
  { path: "/pendingStudents", component: PendingStudents, meta: { requiresAuth: true } },
  { path: "/ourStudents", component: OurStudents, meta: { requiresAuth: true } },
  { path: "/instituteSettings", component: InstituteSettingsPage, meta: { requiresAuth: true } },

  // Admin Dashboard routes
  { path: "/admin_dashboard", component: Students, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/tutors", component: TutorsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/institutions", component: InstitutionsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/verificationRequests", component: VerificationRequestsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/studentReviews", component: StudentReviewsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/gradeManagement", component: GradeManagementPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/userList", component: UsersPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/settingsPage", component: SettingsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/pastPapers", component: PastPapersPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/tutorProfile/:id", component: AdminTutorProfile, meta: { requiresAuth: false } },
  { path: "/admin_dashboard/payments", component: AdminPaymentsPage, meta: { requiresAuth: true } },
  { path : "/admin_dashboard/tutorPayouts", component: TutorPayoutsPage, meta: { requiresAuth: true } },
  { path: "/admin_dashboard/discounts", component: DiscountsPage, meta: { requiresAuth: true } },

  // Payment result routes
  { path: "/payments/success", component: PaymentSuccess, meta: { requiresAuth: false } },
  { path: "/payments/failed", component: PaymentFailed, meta: { requiresAuth: false } },

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  },
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.token) {
    next("/login");
    notifyError("Unauthorized", "You are not logged in");
    return;
  }

  // Auto-redirect admins to admin dashboard when visiting non-admin pages
  if (authStore.token && authStore.user) {
    const role = authStore.user.role;
    if ((role === 'admin' || role === 'super_admin') && !to.path.startsWith('/admin_dashboard')) {
      next('/admin_dashboard');
      return;
    }
  }

  // Redirect incomplete users away from protected routes back to their onboarding flow
  if (to.meta.requiresAuth && authStore.token && authStore.user) {
    const user = authStore.user;
    const role = user.role;
    const isOnboardingIncomplete =
      role === 'admin' || role === 'super_admin' ? false :
      role === 'tutor' ? (!user.registrationCompleted || !user.verificationRequested) :
      !user.registrationCompleted;

    if (isOnboardingIncomplete) {
      const dest = { student: '/studentOnBoarding', tutor: '/tutorOnBoarding', institute: '/institutionOnBoarding' }[role];
      if (dest) { next(dest); return; }
    }
  }

  next();
});

export default router;
